$eve_app_page_sb_catalog $mol_book2_catalog
	- без понятия опять же, что это за компонент Placeholder и зачем он там нужен - 0 шансов и желания разбираться
	Placeholder null
